import { Col, Row } from 'antd';
import { useI18n, useViewContext } from 'core';
import _ from 'lodash';
import { useCallback } from 'react';
import styled from 'styled-components';

const RootComponent = styled.div`
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    border-radius: 6px;
`;

const Header = styled(Row)`
    align-items: center;
    color: ${(props) => props.theme.token.colorPrimary};
    background-color: #fdfdfa;
    padding: 5px 10px;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
`;

const Body = styled.div`
    background-color: #fff;
    min-height: 400px;
    padding: 20px 20px 30px 20px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
`;

const Footer = styled.div`
    background-color: #fdfdfa;
    border-top: 1px solid #ddd;
    padding: 10px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
`;

const Title = styled(Col)`
    flex: none;
    display: inline-block;
    padding-top: 8px;
    font-weight: 400;
    font-size: 22px;
`;

const Action = styled(Col)`
    flex: auto;
    text-align: right;
`;

const TagEtat = styled.span`
    margin-left: 10px;
    padding: 3px 6px;
    font-weight: bold;
    font-size: 10px;
    color: #fff;
    background-color: ${(props) => props.theme.token.colorWarning};
    border-radius: 4px;
`;

const MasterPanel = ({ title = null, label = null, etat = null, headerAction = null, children }) => {
    const { i18n } = useI18n();
    const { uc } = useViewContext();
    const getContent = useCallback(() => {
        if (_.isArray(children)) {
            return children.map((c) => {
                if (c?.key !== 'footer') {
                    return c;
                }
            });
        } else {
            return children;
        }
    }, [children]);

    const getFooterAction = useCallback(() => {
        const footerAction =
            _.isArray(children) &&
            children.find((c) => {
                return c?.key === 'footer';
            });
        if (footerAction) {
            return <Footer>{footerAction}</Footer>;
        }
    }, [children]);

    return (
        <RootComponent>
            <Header>
                <Title flex="none"> {label || (title && i18n(title)) || i18n(uc + '.title')}</Title>
                {etat && <TagEtat>{etat}</TagEtat>}
                <Action>{headerAction}</Action>
            </Header>
            <Body>{getContent()}</Body>
            {getFooterAction()}
        </RootComponent>
    );
};

export default MasterPanel;
